import React from 'react';
import cn from 'classnames';
import styles from './Progress.module.scss';

export const ProgressBar = ({ value }) => (
  <div className="progress">
    <div
      className={cn('progress-bar progress-bar-striped', styles.progressBar)}
      role="progressbar"
      style={{ width: `${value}%` }}
      aria-valuenow={value}
      aria-valuemin="0"
      aria-valuemax="100"
    />
  </div>
);
